"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import useFramerMotion, { AnimatePresence, LazyMotion, m, useReducedMotion } from "@/hooks/useFramerMotion";
import { cn } from "@/utils";
import MarkDown from "@/components/MarkDown";
import { plainHeadingWord } from "./plainHeadingWord";
const parentVariant = {
  initial: {
    opacity: 0.001
  },
  animate: {
    opacity: 1,
    transition: {
      delayChildren: 0.2,
      staggerChildren: 0.12
    }
  }
};
const fadeinAnimationVariants = {
  initial: {
    y: 30,
    skewY: 5,
    opacity: 0.001,
    transformOrigin: "0 50%"
  },
  animate: {
    y: 0,
    skewY: 0,
    opacity: 1
  }
};
type TextGenerateEffectProps = {
  children: string;
  className?: string;
  wordClassName?: string;
};
const TextGenerateEffect = t0 => {
  const $ = _c(11);
  const {
    children,
    className,
    wordClassName
  } = t0;
  const framerMotionFeatures = useFramerMotion();
  const reduceMotion = useReducedMotion();
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setMounted(true);
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== children || $[3] !== className || $[4] !== framerMotionFeatures || $[5] !== mounted || $[6] !== reduceMotion || $[7] !== wordClassName) {
    const lines = children.split("\\");
    const renderWords = () => {
      if (mounted && reduceMotion) {
        return <div className="flex flex-col">{lines.map((line, index) => <div key={`line-${index}`} className="line">{line.split(" ").filter(_temp).map((word_0, idx) => <span key={word_0 + idx} className={cn("word inline-block", wordClassName)}>{plainHeadingWord(word_0) ?? <MarkDown skipParagraph={true}>{word_0 + "&nbsp;"}</MarkDown>}</span>)}</div>)}</div>;
      }
      return <LazyMotion features={framerMotionFeatures}><AnimatePresence><m.div key={`text-${children}`} variants={parentVariant} initial="initial" whileInView="animate" viewport={{
            amount: "some",
            once: true
          }} className="flex flex-col will-change-[opacity]">{lines.map((line_0, index_0) => {
              const wordsArray = line_0.split(" ").filter(_temp2);
              return <div key={`line-${index_0}`} className="line"><AnimatePresence>{wordsArray.map((word_2, idx_0) => <m.span key={word_2 + idx_0} animate={{
                    overflow: "visible"
                  }} transition={{
                    delay: 0.8
                  }} className="relative overflow-hidden"><m.span className={cn("word inline-block will-change-[opacity,transform]", wordClassName)} variants={fadeinAnimationVariants} transition={{
                      type: "spring"
                    }}>{plainHeadingWord(word_2) ?? <MarkDown skipParagraph={true}>{word_2 + "&nbsp;"}</MarkDown>}</m.span></m.span>)}</AnimatePresence></div>;
            })}</m.div></AnimatePresence></LazyMotion>;
    };
    let t4;
    if ($[9] !== className) {
      t4 = cn(className);
      $[9] = className;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = <div className={t4}>{renderWords()}</div>;
    $[2] = children;
    $[3] = className;
    $[4] = framerMotionFeatures;
    $[5] = mounted;
    $[6] = reduceMotion;
    $[7] = wordClassName;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default TextGenerateEffect;
function _temp(word) {
  return word;
}
function _temp2(word_1) {
  return word_1;
}